import React from "react";
import { typography, textColors, borders, surfaces, interactive } from "../../../design-system/tokens";

function DecorationChip({ value, label, selected, onSelect }) {
  const style = {
    textDecoration:
      value === "none"
        ? "none"
        : value === "line-through"
        ? "line-through"
        : value === "overline"
        ? "overline"
        : "underline",
  };
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`border rounded-lg w-9 h-9 flex items-center justify-center transition-all ${
        selected ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm` : `${borders.default} ${surfaces.tertiary} ${surfaces.hover}`
      }`}
      aria-pressed={selected}
      aria-label={typeof label === "string" ? label : undefined}
      title={typeof label === "string" ? label : undefined}
    >
      <span className={`text-lg leading-none select-none ${selected ? "text-white" : textColors.primary}`} style={style}>
        A
      </span>
    </button>
  );
}

export default function TextDecorationField({ label, help, value, onChange, choices }) {
  const normalized = (choices || []).map((c) => ({ value: c.value, label: c.label }));
  return (
    <div className="field-wrapper">
      <div className="flex flex-wrap items-center gap-2">
        <label className={`mr-2 whitespace-nowrap ${typography.label} ${textColors.secondary}`}>{label}</label>
        <div className="flex flex-wrap items-center gap-2">
          {normalized.map((c) => (
            <DecorationChip
              key={c.value}
              value={c.value}
              label={c.label}
              selected={value === c.value}
              onSelect={(val) => onChange(val)}
            />
          ))}
        </div>
      </div>
      {help && <div className={`mt-1 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}


